<template>
    <MainLayout>
        <LoaderPage v-if="loadingPage" />
        <HeaderBreadcrumb
            :items="items"
            :page="page"
        />
        <div class="container">
            <br><br>
            <div class="row min-h-85">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            Adicionar leituras
                        </div>
                        <div class="card-body">
                        <p>Adicione leituras de Coletores Winckieel ao sistema Cloud. Selecione o silo ao qual a leitura pertence e carregue o arquivo JSON correspondente.</p>
                            <form @submit.prevent="handleSubmit" class="row g-3">
                                <div class="col-md-6">
                                    <label for="siloSelect" class="form-label">Selecione o Silo</label>
                                    <select id="siloSelect" v-model="selectedSilo" class="form-select" required>
                                        <option v-for="silo in silos" :key="silo.id" :value="silo.id">{{ silo.nome }}</option>
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <label for="jsonFile" class="form-label">Arquivo JSON</label>
                                    <input type="file" id="jsonFile" @change="handleFileChange" class="form-control" required />
                                </div>
                                <div class="col-12 d-flex justify-content-end">
                                    <button 
                                        style="margin-right: 1rem;" 
                                        type="submit" 
                                        class="btn btn-success"
                                        :disabled="!formularioPreenchido" 
                                    >
                                        Enviar Leitura
                                    </button>
                                    <button 
                                        type="button" 
                                        class="btn btn-secondary" 
                                        @click="limparForm"
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout.vue';
import HeaderBreadcrumb from '@/components/ui/App/HeaderBreadcrumb.vue';
import LoaderPage from '@/components/ui/LoaderPage.vue';
import { useToast } from 'vue-toastification';
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';

export default {
    components: {
        MainLayout,
        HeaderBreadcrumb,
        LoaderPage
    },

    data() {
        return {
            items: [
                {"descricao": "Winckieel", "url": "/v1/unidades"},
                {"descricao": "Unidade", "url": "/v1/unidades/"+ this.$route.params.unidade}, 
            ],
            page: "Adicionar leituras"
        }
    },

    setup() {
        const silos = ref([]);
        const store = useStore();
        const unidade = ref({});
        const toast = useToast();
        const loadingPage = ref(true);
        const route = useRoute();
        const selectedSilo = ref(null);
        const jsonFile = ref(null);
        const formularioPreenchido = ref(false);

        onMounted(async () => {
            loadingPage.value = true;
            const unidadeId = route.params.unidade;

            try {
                await store.dispatch("unidade/fetchUnidade", unidadeId);
                unidade.value = store.state.unidade.unidade;

                await store.dispatch("silos/fetchSilosByUnidade", unidadeId);
                silos.value = store.state.silos.silos;

            } catch (error) {
                console.error("Erro ao buscar unidade ou silos:", error);
                toast.error("Erro ao buscar dados");
            }
            loadingPage.value = false;
        });

        const handleFileChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                jsonFile.value = file;
            }
        };

        const handleSubmit = async () => {
            let siloId = selectedSilo.value;
            let json = jsonFile.value;

            try {
                const response = await store.dispatch("leituras/uploadLeitura", { siloId, json });
                (response.data.status == 200 ? toast.success : toast.error)(response.data.response);
                limparForm();
            } catch (error) {
                console.log(error.response.data.error)
                toast.error(error.response.data.error || "Erro ao enviar leitura");
            }
        };

        const limparForm = () => {
            selectedSilo.value = null;
            jsonFile.value = null;
            document.getElementById('jsonFile').value = null;
        };

        watch([selectedSilo, jsonFile], () => {
            formularioPreenchido.value = !!selectedSilo.value && !!jsonFile.value;
        });

        return {
            loadingPage,
            silos,
            selectedSilo,
            handleFileChange,
            handleSubmit,
            limparForm,
            formularioPreenchido
        }
    }
}
</script>
